module.exports = __webpack_public_path__ + "static/media/washington-dc-14.7d10c2ee.jpg";